import Store from '../Store/Store';
import { ApiKey, Prompt } from '../Types';
import { SaveApiKey } from '../Types/ServiceTypes';
import requestClient from '../components/Utility/RequestClient';

const resolveDemo = () => Store.getState().environment.demoInstance;

export const apiKeyService = {
    saveApiKey: async (type: string, data: SaveApiKey): Promise<any> => {
        return requestClient.post<ApiKey>(`/apikeys/${type}`, data);
    },

    getPrompts: async (): Promise<{ data: Prompt[] }> => {
        return requestClient.get<Prompt[]>(`${resolveDemo() ? '/demo' : ''}/prompts/get`);
    },

    getApiKey: async (apiKeyIdentifier: string): Promise<{ data: ApiKey }> => {
        return requestClient.get<ApiKey>(`${resolveDemo() ? '/demo' : ''}/apikeys/get/${apiKeyIdentifier}`);
    },

    getApiKeysByPage: (
        page: number,
        itemsPerPage: number,
        additionalParams?: Record<string, any>,
    ): Promise<{ data: { data: ApiKey[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? '/demo' : ''}/apikeys/get`, {
                params: {
                    page,
                    itemsPerPage,
                    ...additionalParams,
                },
            })
            .then((response: any) => response);
    },

    getApiKeys: async (): Promise<{ data: { data: ApiKey[]; total: number } }> => {
        return requestClient.get<{ data: ApiKey[]; total: number }>(`${resolveDemo() ? '/demo' : ''}/apikeys/get`);
    },

    deleteApiKey: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/apikeys/delete/${identifier}`);
    },

    getAllApiKeysPaginated: async (itemsPerPage: number = 50): Promise<ApiKey[]> => {
        const firstResponse = await apiKeyService.getApiKeysByPage(1, itemsPerPage);
        const { data: firstData, total } = firstResponse.data;

        const totalPages = Math.ceil(total / itemsPerPage);

        if (totalPages <= 1) {
            return firstData;
        }

        const pagePromises: Promise<{ data: { data: ApiKey[]; total: number } }>[] = [];
        for (let page = 2; page <= totalPages; page++) {
            pagePromises.push(apiKeyService.getApiKeysByPage(page, itemsPerPage));
        }

        const responses = await Promise.all(pagePromises);
        const allData = responses.flatMap((res) => res.data.data);

        return firstData.concat(allData);
    },
};
